export default __webpack_public_path__ + "static/media/impact-icon-active.334026e3.svg";